import styled from 'styled-components/macro';

export const CoronaDelayInfoStyled = styled.p`
  padding: 1rem;
  color: ${(props) => props.theme.colors.text.white};
  background-color: ${(props) => props.theme.colors.status.error};
`;
